import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';

@Component({
  selector: 'app-account-activation',
  templateUrl: './account-activation.component.html',
  styleUrls: ['./account-activation.component.scss']
})
export class AccountActivationComponent implements OnInit, OnDestroy {
  verifying = true;
  success = false;
  errorMessage = '';
  currentYear = new Date().getFullYear();

  redirectCountdown = 5;
  private countdownInterval: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService
  ) {}

  ngOnInit(): void {
    const uid = this.route.snapshot.queryParamMap.get('uid');
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!uid || !token) {
      this.handleVerificationError('Paramètres uid ou token manquants');
      return;
    }

    this.verifyEmail(uid, token);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  verifyEmail(uid: string, token: string): void {
    const body = {
      uid: uid,
      token: token
    };

    this.authService.verifyEmail(body).subscribe({
      next: (response) => {
        this.verifying = false;
        this.success = true;

        this.sweetAlertService.toastSuccess(
          'Email vérifié avec succès !',
          3000
        );

        this.startRedirectCountdown();
      },
      error: (error: HttpErrorResponse) => {
        this.handleVerificationError(
          error.error?.message ||
          error.error?.error ||
          'Le lien de vérification est invalide ou a expiré'
        );
      }
    });

  }

  handleVerificationError(message: string): void {
    this.verifying = false;
    this.success = false;
    this.errorMessage = message;
  }

  startRedirectCountdown(): void {
    this.redirectCountdown = 5;

    this.countdownInterval = setInterval(() => {
      this.redirectCountdown--;

      if (this.redirectCountdown <= 0) {
        clearInterval(this.countdownInterval);
        this.goToLogin();
      }
    }, 1000);
  }

  goToLogin(): void {
    this.router.navigate(['/auth/signin']);
  }

  goToResendVerification(): void {
    // Redirection vers la page de renvoi d'email de vérification
    this.router.navigate(['/auth/resend-verification']);
  }
}
